module.exports = __webpack_public_path__ + "static/media/titan.b43fd365.JPG";